export default {
  title: 'Notas importantes',
  buttons: {
    add_note: 'Añadir nota',
  },
};
